/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-cycle
import { store } from '@/store';

import Sortable from 'sortablejs';

// eslint-disable-next-line import/no-cycle
import {
  ElementPartTypeEnum,
  HistoryType, SelectedStructureSyncPart, TemplateStructureEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import {
  addElementTypeByLang,
  addOrRemoveJustImageClass,
  insertEmbedTemplateInSelectedElement, refreshSectionsConfig,
  resetIframe,
  setTemplateConfigurationKeyInState,
  TemplateEditorState as state,
  togglePanel,
  updateSectionIdOfTranslationsInState, updateSectionsInState,
  setSelectedTranslationId,
  setShowConfigurationPanelCallback,
  getTranslationIdFromImportedTemplateElement, setPerfectSizeForImage,
  markTemplateAsEdited, unlinkSyncElement,
  moveWidgetFromSectionToAnother,
} from '@/composables/template-editor/TemplateEditor';
// eslint-disable-next-line import/no-cycle
import { RAW_PLACEHOLDER_STRUCTURE_MAP } from '@/components/template-builder/utils/raw-html-templates';
// eslint-disable-next-line import/no-cycle
import { getParents } from '@/helpers';
// eslint-disable-next-line import/no-cycle
import { removeColumn } from '@/components/template-builder/utils/action-buttons-handlers';
// eslint-disable-next-line import/no-cycle
import {
  addItemElementDecorations,
  removeItemElementDecorations,
} from '@/components/template-builder/utils/active-item-builder';
import { ref } from 'vue';
// eslint-disable-next-line import/no-cycle
import { checkIfSavePointNeeded, createHistory } from '@/composables/template-editor/History';

// eslint-disable-next-line import/no-cycle
import { Maybe } from '@/types/generated-types/graphql';
// eslint-disable-next-line import/no-cycle
import { delay } from '@/helpers/helpers';
// eslint-disable-next-line import/no-cycle
import {
  addOrUpdateDynamicStyle,
  getTemplateColumns,
  getTemplateSections,
  getTemplateWidgets, moveDynamicStyleFromSectionToAnother,
} from './parser';
// eslint-disable-next-line import/no-cycle
import {
  getTemplateIframeDocument,
  getTemplateParentTypeByType,
  getWidgetType,
  getSectionParent,
  isEmailTemplate,
  isDisplayTemplate,
  generateUniqStructureId,
} from './helpers';
// eslint-disable-next-line import/no-cycle
import {
  ACTIONS_BUTTON_GROUP,
  ANIMATION_SPEED,
  BUILDER_ELEMENT_ACTIVE_CLASS,
  BUILDER_ELEMENT_HOVER_CLASS,
  BUILDER_EMBED_CONTAINER_HOVER_CLASS,
  BUILDER_EMBED_TEMPLATE_CONTAINERS,
  BUILDER_SORTABLE_CHOSEN_CLASS,
  BUILDER_SORTABLE_DRAG_CLASS,
  BUILDER_SORTABLE_GHOST_CLASS,
  BUILDER_SORTABLE_PLACEHOLDER_HOVER_CLASS,
  COLUMN_WITH_PLACEHOLDER_CLASS,
  TEMPLATE_PART_ELEMENT_IDENTIFIER,
  TEMPLATE_PART_ELEMENT_PART_TYPE,
  TEMPLATE_SECTION_CLASS,
  TEMPLATE_SECTION_CONTENT_ID_SUFFIX,
  TEMPLATE_SECTION_IDENTIFIER,
  TEMPLATE_SYNC_ELEMENT_IDENTIFIER,
  TEMPLATE_WIDGET_IDENTIFIER,
  WIDGET_DRAGGABLE_CLASS, WIDGET_DRAGGABLE_IDENTIFIER,
  WIDGET_DROPPABLE_CLASS, WIDGET_DROPPABLE_IDENTIFIER,
  WIDGETS_PLACEHOLDER_IDENTIFIER,
} from './constants';

const setSectionHoverStyles = (section: HTMLElement) => {
  section.classList.add(BUILDER_ELEMENT_HOVER_CLASS);
};

const resetSectionHoverStyles = (section: HTMLElement) => {
  section.classList.remove(BUILDER_ELEMENT_HOVER_CLASS);
};

export const handleWidgetColumnItemDecorations = (element: HTMLElement, type: TemplateStructureEnum, selectedStructure: any, syncId: any) => {
  const template = getTemplateIframeDocument();
  if (selectedStructure) {
    const selectedStructureElement = template.querySelector(`#${selectedStructure.identifier}`);
    if (selectedStructure && !syncId && selectedStructureElement) {
      removeItemElementDecorations(selectedStructureElement as HTMLElement);
    } else if (syncId) {
      const syncElement = template.querySelector(`#${syncId}`);
      if (syncElement) {
        addItemElementDecorations(syncElement as HTMLElement, TemplateStructureEnum.SECTION);
      }
      if (selectedStructure && selectedStructure.identifier !== element.id && selectedStructureElement && element) {
        const selectedSyncElement = store.getters['liveEditor/getSelectedSyncElement'];
        if (selectedSyncElement && selectedSyncElement.elementId !== selectedStructure.identifier) {
          removeItemElementDecorations(selectedStructureElement as HTMLElement);
        }
        addItemElementDecorations(element as HTMLElement, type);
      }
    }
  } else if (!selectedStructure && element) {
    addItemElementDecorations(element as HTMLElement, type);
  }
};

const handleWidgetColumnClick = (element: HTMLElement, checkIfElementisSync: boolean, checkReset: boolean, acceptCallback: Function, exitEditModeCallback: Function) => {
  const resetExitEditMode = () => {
    store.commit('liveEditor/setExitEditModeModalVisible', false);
    store.commit('liveEditor/setExitEditModeCallback', null);
  };

  const selectedSyncElement = store.getters['liveEditor/getSelectedSyncElement'];
  const section = getSectionParent(element);
  if (section) {
    const sectionElementSyncId = section.getAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)
      && !section.getAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE) && isEmailTemplate(state.template?.type);
    if (sectionElementSyncId && !selectedSyncElement) {
      resetExitEditMode();
      store.dispatch('liveEditor/showSyncElementWarning', {
        elementId: section.getAttribute('id'),
        elementType: TemplateStructureEnum.SECTION,
        acceptCallback: () => {
          acceptCallback(section.getAttribute('id') || '');
        },
        rejectCallback: null,
      });
    } else {
      // eslint-disable-next-line no-lonely-if
      if (!selectedSyncElement) {
        // Check if widget is a synced element or not
        if (checkIfElementisSync && element.getAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) && !element.getAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE)) {
          resetExitEditMode();
          store.dispatch('liveEditor/showSyncElementWarning', {
            elementId: element.getAttribute('id'),
            elementType: TemplateStructureEnum.WIDGET,
            acceptCallback,
            rejectCallback: null,
          });
        } else {
          acceptCallback();
          resetExitEditMode();
        }
      } else if (selectedSyncElement
          && isEmailTemplate(state.template?.type)
          && section.getAttribute('id') === selectedSyncElement.elementId
          && selectedSyncElement.elementPartType !== ElementPartTypeEnum.STYLES
      ) {
        // Check if widget inside the synced element
        acceptCallback(selectedSyncElement.elementId);
        resetExitEditMode();
      } else if (selectedSyncElement
          && ((section.getAttribute('id') !== selectedSyncElement.elementId)
            || (isDisplayTemplate(state.template?.type) && selectedSyncElement.elementType === TemplateStructureEnum.DESIGN))
          && !checkReset) {
        store.commit('liveEditor/setExitEditModeModalVisible', true);
        store.commit('liveEditor/setExitEditModeCallback', exitEditModeCallback);
      }
    }
  }
};

const columnsButtonClickListener = (event: any) => {
  event.preventDefault();
  event.stopPropagation();
  let column = event.target;
  if (!column.classList || !column.classList.contains(WIDGET_DROPPABLE_IDENTIFIER)) {
    column = getParents(column, WIDGET_DROPPABLE_CLASS);

    if (column && column.length) {
      [column] = column;
    }
  }

  if (column.classList.contains(WIDGET_DROPPABLE_IDENTIFIER)) {
    const acceptCallback = () => {
      removeColumn(event, column);
      const section = getSectionParent(column);
      if (section) {
        const sectionElementSyncId = section.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)
          && !section.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE) && isEmailTemplate(state.template?.type);
        if (sectionElementSyncId) {
          const selectedSyncElement = store.getters['liveEditor/getSelectedSyncElement'];
          if (selectedSyncElement) {
            togglePanel('configurationPanel', null).then(() => {
              if (selectedSyncElement) {
                store.dispatch('liveEditor/prepareStructureConfiguration', selectedSyncElement.structureConfiguration);
              }
            });
          }
        }
      }
    };

    const exitEditModeCallback = async (checkReset = true) => {
      // We delay the execution because of the dom is not reconstructed properly yet
      if (checkReset) {
        await delay(100);
      }

      handleWidgetColumnClick(column as HTMLElement, false, checkReset, acceptCallback, exitEditModeCallback);
    };

    exitEditModeCallback(false);
  }
};

const columnsMouseEnterListener = (event: any) => {
  event.preventDefault();
  event.stopPropagation();

  let column = event.target;
  if (!column.classList || !column.classList.contains(WIDGET_DROPPABLE_IDENTIFIER)) {
    column = getParents(column, WIDGET_DROPPABLE_CLASS);

    if (column && column.length) {
      [column] = column;
    }
  }

  const selectedSyncElement = store.getters['liveEditor/getSelectedSyncElement'];

  if (column.classList.contains(WIDGET_DROPPABLE_IDENTIFIER)) {
    setSectionHoverStyles(column);
    if (!selectedSyncElement || (selectedSyncElement && selectedSyncElement.elementType !== TemplateStructureEnum.DESIGN)) {
      addItemElementDecorations(column, TemplateStructureEnum.COLUMN);
    }
  }
};

const columnsMouseLeaveListener = (event: any) => {
  event.preventDefault();
  event.stopPropagation();

  let column = event.target;
  if (!column.classList || !column.classList.contains(WIDGET_DROPPABLE_IDENTIFIER)) {
    column = getParents(column, WIDGET_DROPPABLE_CLASS);

    if (column && column.length) {
      [column] = column;
    }
  }

  const selectedStructure = store.getters['liveEditor/getSelectedStructure'];

  if (column.classList.contains(WIDGET_DROPPABLE_IDENTIFIER)) {
    event.target.classList.remove(BUILDER_ELEMENT_HOVER_CLASS);
    if (!selectedStructure || (selectedStructure && selectedStructure.identifier !== column.id)) {
      removeItemElementDecorations(column);
    }
  }
};

const columsClickListener = (event: any) => {
  event.preventDefault();
  event.stopPropagation();

  let column = event.target;
  if (!column.classList || !column.classList.contains(WIDGET_DROPPABLE_IDENTIFIER)) {
    column = getParents(column, WIDGET_DROPPABLE_CLASS);

    if (column && column.length) {
      [column] = column;
    }
  }

  if (column.classList.contains(WIDGET_DROPPABLE_IDENTIFIER)) {
    const selectedStructure = store.getters['liveEditor/getSelectedStructure'];

    const acceptCallback = (syncId = '') => {
      togglePanel('configurationPanel', event).then(() => {
        handleWidgetColumnItemDecorations(column as HTMLElement, TemplateStructureEnum.COLUMN, selectedStructure, syncId);
        store.dispatch('liveEditor/prepareStructureConfiguration', {
          type: TemplateStructureEnum.COLUMN,
          identifier: column.id,
        });
      });
    };

    const exitEditModeCallback = async (checkReset = true) => {
      // We delay the execution because of the dom is not reconstructed properly yet
      if (checkReset) {
        await delay(100);
      }

      handleWidgetColumnClick(column as HTMLElement, false, checkReset, acceptCallback, exitEditModeCallback);
    };

    exitEditModeCallback(false);
  }
};

export const addColumnsListeners = (columns?: HTMLElement[]) => {
  const columnsArray = (columns || getTemplateColumns());
  columnsArray.forEach((column: any) => {
    // We check if the column has children. If false, we create a placeholder
    if (column.children.length === 0) {
      const div = document.createElement('div');
      div.innerHTML = RAW_PLACEHOLDER_STRUCTURE_MAP[getTemplateParentTypeByType(state.template?.type)]();
      const placeholder = div.getElementsByClassName(WIDGETS_PLACEHOLDER_IDENTIFIER)[0];
      column.appendChild(placeholder);
      column.classList.add(COLUMN_WITH_PLACEHOLDER_CLASS);
    } else if (column.querySelector(`.${WIDGETS_PLACEHOLDER_IDENTIFIER}`)) {
      column.classList.add(COLUMN_WITH_PLACEHOLDER_CLASS);
    } else {
      column.classList.remove(COLUMN_WITH_PLACEHOLDER_CLASS);
    }

    // For each placeholder found, we add the ability to remove the column.
    if (column.classList.contains(COLUMN_WITH_PLACEHOLDER_CLASS)) {
      if (getTemplateColumns().length === 1) {
        // If there is only one column in the template, we remove the delete button
        // eslint-disable-next-line no-unused-expressions
        column.querySelector('.button-delete')?.remove();
      } else {
        const button = column.querySelector('svg:not(.widget-placeholder)');
        if (button) {
          button.removeEventListener('click', columnsButtonClickListener);
          button.addEventListener('click', columnsButtonClickListener);
        }
      }
    }

    if (column.classList.contains(COLUMN_WITH_PLACEHOLDER_CLASS)) {
      if (typeof column.haveEventListener === 'undefined') {
        column.haveEventListener = true;
        column.removeEventListener('mouseenter', columnsMouseEnterListener);
        column.addEventListener('mouseenter', columnsMouseEnterListener);

        column.removeEventListener('mouseleave', columnsMouseLeaveListener);
        column.addEventListener('mouseleave', columnsMouseLeaveListener);

        column.removeEventListener('click', columsClickListener);
        column.addEventListener('click', columsClickListener);
      }

      addElementTypeByLang(column);
    } else {
      column.removeEventListener('mouseenter', columnsMouseEnterListener);
      column.removeEventListener('mouseleave', columnsMouseLeaveListener);
      column.removeEventListener('click', columsClickListener);
    }
  });
};

const sectionsMouseEnterListener = (event: any) => {
  let section = event.target;
  if (!section.classList || !section.classList.contains(TEMPLATE_SECTION_CLASS)) {
    section = getParents(event.target, `.${TEMPLATE_SECTION_CLASS}`);

    if (section && section.length) {
      [section] = section;
    }
  }

  const selectedStructure = store.getters['liveEditor/getSelectedStructure'];
  const selectedSyncElement = store.getters['liveEditor/getSelectedSyncElement'];

  if (section.classList.contains(TEMPLATE_SECTION_CLASS) && !section.classList.contains(BUILDER_ELEMENT_ACTIVE_CLASS)) {
    setSectionHoverStyles(section);
    if (!selectedStructure || (selectedStructure && selectedStructure.type !== TemplateStructureEnum.SECTION)) {
      if (!selectedSyncElement || (selectedSyncElement && selectedSyncElement.elementType !== TemplateStructureEnum.DESIGN)) {
        addItemElementDecorations(section, TemplateStructureEnum.SECTION);
      }
    }
  }
};

const sectionsMouseMoveListener = (event: any) => {
  // We check if the target is inside a widget. If true, we remove hover class, else, we add hover class
  const widget = getParents(event.target, WIDGET_DRAGGABLE_CLASS);
  let column = event.target;
  if (!column.classList || !column.classList.contains(WIDGET_DROPPABLE_IDENTIFIER)) {
    column = getParents(column, WIDGET_DROPPABLE_CLASS);

    if (column && column.length) {
      [column] = column;
    }
  }

  let section = event.target;
  if (!section.classList || !section.classList.contains(TEMPLATE_SECTION_CLASS)) {
    section = getParents(section, `.${TEMPLATE_SECTION_CLASS}`);

    if (section && section.length) {
      [section] = section;
    }
  }

  const selectedStructure = store.getters['liveEditor/getSelectedStructure'];
  const selectedSyncElement = store.getters['liveEditor/getSelectedSyncElement'];

  if ((widget && widget.length) || (column && column.classList && column.classList.contains(WIDGET_DROPPABLE_IDENTIFIER))) {
    resetSectionHoverStyles(section);
    if (selectedStructure && selectedStructure.identifier !== section.id) {
      if (!selectedSyncElement || (selectedSyncElement && selectedSyncElement.elementId !== section.id)) {
        removeItemElementDecorations(section);
      }
    } else if (!selectedStructure) {
      removeItemElementDecorations(section);
    }
  } else {
    setSectionHoverStyles(section);
    if (!selectedStructure || (selectedStructure && selectedStructure.type !== TemplateStructureEnum.SECTION)) {
      if (!selectedSyncElement || (selectedSyncElement && selectedSyncElement.elementType !== TemplateStructureEnum.DESIGN)) {
        addItemElementDecorations(section, TemplateStructureEnum.SECTION);
      }
    }
  }
};

const sectionsMouseLeaveListener = (event: any) => {
  let section = event.target;
  if (!section.classList || !section.classList.contains(TEMPLATE_SECTION_CLASS)) {
    section = getParents(event.target, `.${TEMPLATE_SECTION_CLASS}`);

    if (section && section.length) {
      [section] = section;
    }
  }

  resetSectionHoverStyles(section);

  const selectedStructure = store.getters['liveEditor/getSelectedStructure'];

  if (!selectedStructure || (selectedStructure && selectedStructure.identifier !== section.id)) {
    const selectedSyncElement = store.getters['liveEditor/getSelectedSyncElement'];
    if (!selectedSyncElement || (selectedSyncElement && selectedSyncElement.elementId !== section.id)) {
      removeItemElementDecorations(section);
    }
  }

  const template = getTemplateIframeDocument();
  const tooltipElement: HTMLElement | null = template.querySelector(`#${section.id.replaceAll('_content', '')} .tooltip`);
  if (tooltipElement && tooltipElement.style.visibility !== 'hidden') {
    tooltipElement.style.visibility = 'hidden';
  }
};

const sectionsClickListener = (event: any) => {
  event.stopPropagation();

  let section = event.target;
  if (!section.classList || !section.classList.contains(TEMPLATE_SECTION_CLASS)) {
    section = getParents(event.target, `.${TEMPLATE_SECTION_CLASS}`);

    if (section && section.length) {
      [section] = section;
    }
  }

  const onSectionsClick = () => {
    if (event && !(event.target as HTMLElement).id.match(new RegExp('load-section')) && !state.leftToolbar.show.translationPanel) {
      togglePanel('configurationPanel', event).then(() => {
        // We check first if there is another selected element and remove the element decorations if so
        const selectedStructure = store.getters['liveEditor/getSelectedStructure'];
        if (selectedStructure) {
          if (selectedStructure.identifier !== section.id) {
            const template = getTemplateIframeDocument();
            const selectedElement = template.querySelector(`#${selectedStructure.identifier}`);
            if (selectedElement) {
              removeItemElementDecorations(selectedElement as HTMLElement);
            }
          }
        }

        // Add element decoration to the new selected element
        addItemElementDecorations(section, TemplateStructureEnum.SECTION);

        if (section.classList && section.classList.contains(TEMPLATE_SECTION_CLASS)) {
          // We prepare structure configuration and open the configuration panel only if we click inside a section, not the load-section button
          store.dispatch('liveEditor/prepareStructureConfiguration', {
            type: TemplateStructureEnum.SECTION,
            identifier: section.id.replaceAll(TEMPLATE_SECTION_CONTENT_ID_SUFFIX, ''),
          });
        }
      });
    }
  };

  const exitEditModeCallback = async (resetExitMode = true) => {
    // We delay the execution because of the dom is not reconstructed properly yet
    if (resetExitMode) {
      await delay(100);
    }
    const resetExitEditMode = () => {
      store.commit('liveEditor/setExitEditModeModalVisible', false);
      store.commit('liveEditor/setExitEditModeCallback', null);
    };

    const selectedSyncElement = store.getters['liveEditor/getSelectedSyncElement'];
    if (event && event.target && !state.leftToolbar.show.translationPanel) {
      if (!selectedSyncElement) {
        const elementSyncId = section.getAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) && !section.getAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE);
        if (elementSyncId) {
          resetExitEditMode();
          store.dispatch('liveEditor/showSyncElementWarning', {
            elementId: section.getAttribute('id'),
            elementType: TemplateStructureEnum.SECTION,
            acceptCallback: onSectionsClick,
            rejectCallback: null,
          });
        } else {
          onSectionsClick();
          if (resetExitMode) {
            resetExitEditMode();
          }
        }
      } else {
        // Check if same section
        // eslint-disable-next-line no-lonely-if
        if (section.getAttribute('id') === selectedSyncElement.elementId) {
          onSectionsClick();
          if (resetExitMode) {
            resetExitEditMode();
          }
        } else if (section.getAttribute('id') !== selectedSyncElement.elementId && !resetExitMode) {
          store.commit('liveEditor/setExitEditModeModalVisible', true);
          store.commit('liveEditor/setExitEditModeCallback', exitEditModeCallback);
        }
      }
    }
  };

  exitEditModeCallback(false);
};

export const addSectionsListeners = (sections?: HTMLElement[]) => {
  (sections || getTemplateSections()).forEach((section: any) => {
    if (typeof section.haveEventListener === 'undefined') {
      section.haveEventListener = true;

      section.removeEventListener('mouseenter', sectionsMouseEnterListener);
      section.addEventListener('mouseenter', sectionsMouseEnterListener);

      section.removeEventListener('mousemove', sectionsMouseMoveListener);
      section.addEventListener('mousemove', sectionsMouseMoveListener);

      section.removeEventListener('mouseleave', sectionsMouseLeaveListener);
      section.addEventListener('mouseleave', sectionsMouseLeaveListener);

      section.removeEventListener('click', sectionsClickListener);
      section.addEventListener('click', sectionsClickListener);
    }
    addElementTypeByLang(section);
  });
};

const widgetsMouseEnterEvent = (event: any) => {
  const chooseEmbedPosition = ref(store.getters['liveEditor/getActiveEmbedPositionChooser']);
  if (!chooseEmbedPosition.value && !event.target.classList.contains(BUILDER_ELEMENT_HOVER_CLASS)) {
    event.target.classList.add(BUILDER_ELEMENT_HOVER_CLASS);

    const selectedStructure = store.getters['liveEditor/getSelectedStructure'];
    const selectedSyncElement = store.getters['liveEditor/getSelectedSyncElement'];

    if (!selectedSyncElement || (selectedSyncElement && selectedSyncElement.elementType !== TemplateStructureEnum.DESIGN)) {
      const targetSection = getSectionParent(event.target);
      if (!selectedSyncElement || (selectedSyncElement.elementId === targetSection?.id)) {
        addItemElementDecorations(event.target, TemplateStructureEnum.WIDGET);
      }
    }

    if (!selectedStructure) {
      // Remove section hover class if hovered element is a widget
      const section = getParents(event.target, `.${TEMPLATE_SECTION_CLASS}`);

      if (section && section.length) {
        resetSectionHoverStyles(section[0]);
        removeItemElementDecorations(section[0]);
      }
    }
  }
};

const widgetsMouseLeaveListener = (event: any) => {
  const chooseEmbedPosition = store.getters['liveEditor/getActiveEmbedPositionChooser'];

  if (!chooseEmbedPosition) {
    const selectedStructure = store.getters['liveEditor/getSelectedStructure'];

    if (!selectedStructure || (selectedStructure && selectedStructure.identifier !== event.target.id)) {
      removeItemElementDecorations(event.target);
    }
  }
};

const widgetsClickListener = (event: any) => {
  // Check if target is inside widget's toolbar.
  // If true, we let the action do. Else, we prevent the action and stop the propagation
  const parentOfTarget = getParents(event.target, `.${ACTIONS_BUTTON_GROUP}`);

  const getWidget = () => {
    let widget = event.target;
    if (!widget.classList || !widget.classList.contains(WIDGET_DRAGGABLE_IDENTIFIER)) {
      widget = getParents(event.target, WIDGET_DRAGGABLE_CLASS);

      if (widget && widget.length) {
        [widget] = widget;
      }
    }
    return widget;
  };

  const widget = getWidget();

  const selectedStructure = store.getters['liveEditor/getSelectedStructure'];

  if (!parentOfTarget || parentOfTarget.length === 0) {
    const acceptCallback = (syncId = '') => {
      const chooseEmbedPosition = store.getters['liveEditor/getActiveEmbedPositionChooser'];

      if (!chooseEmbedPosition) {
        const showConfigurationPanel = () => {
          // If left panel is open, we close it
          togglePanel('configurationPanel', event)
            .then(() => {
              handleWidgetColumnItemDecorations(widget, TemplateStructureEnum.WIDGET, selectedStructure, syncId);
              if (widget && widget.classList && widget.classList.contains(WIDGET_DRAGGABLE_IDENTIFIER)) {
                store.dispatch('liveEditor/prepareStructureConfiguration', {
                  type: TemplateStructureEnum.WIDGET,
                  identifier: widget.id,
                  widgetType: getWidgetType(widget.getAttribute('data-widgettype')),
                });
              }
            });
        };

        if (state.leftToolbar.show.translationPanel) {
          const translationId = getTranslationIdFromImportedTemplateElement(event.target);
          if (translationId) {
            setSelectedTranslationId(translationId);
          }
          if (widget && widget.classList && !widget.getAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)) {
            setShowConfigurationPanelCallback(showConfigurationPanel);
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (state.leftToolbar.show.configurationPanel && store.getters['liveEditor/getWaitForChanges']) {
            // Add to store
            store.commit('liveEditor/setChangesCallback', showConfigurationPanel);
          } else {
            showConfigurationPanel();
          }
        }
      }
    };

    event.preventDefault();
    event.stopPropagation();
    if (state.leftToolbar.show.translationPanel) {
      acceptCallback();
    } else {
      const exitEditModeCallback = async (checkReset = true) => {
        // We delay the execution because of the dom is not reconstructed properly yet
        if (checkReset) {
          await delay(100);
        }

        handleWidgetColumnClick(widget as HTMLElement, true, checkReset, acceptCallback, exitEditModeCallback);
      };

      exitEditModeCallback(false);
    }
  }
};

export const addWidgetsListeners = (widgets?: HTMLElement[]) => {
  (widgets || getTemplateWidgets()).forEach((widget: any) => {
    if (typeof widget.haveEventListener === 'undefined') {
      widget.haveEventListener = true;
      widget.addEventListener('mouseenter', (event: any) => {
        widgetsMouseEnterEvent(event);
      });
      widget.addEventListener('mouseleave', (event: any) => {
        widgetsMouseLeaveListener(event);
      });

      widget.addEventListener('click', (event: any) => {
        widgetsClickListener(event);
      }, true);
    }
    addElementTypeByLang(widget);
  });
};

// Collection pour stocker les instances de Sortable
export const sortableGlobalInstances: any[] = [];
export const sortableIframeInstances: any[] = [];

export const destroyIframeSortables = () => {
  sortableIframeInstances.forEach((instance, index) => {
    if (instance.el) {
      instance.destroy();
      instance.el = null;
    }
    sortableIframeInstances[index] = null; // Explicitly nullify instance
  });
  sortableIframeInstances.length = 0; // Empty the array
};

export const destroyAllSortables = (onlyGlobal = false) => {
  if (!onlyGlobal) {
    sortableIframeInstances.forEach((instance, index) => {
      if (instance.el) {
        instance.destroy();
        instance.el = null;
      }
      sortableIframeInstances[index] = null; // Explicitly nullify instance
    });
    sortableIframeInstances.length = 0; // Empty the array
  }

  sortableGlobalInstances.forEach((instance, index) => {
    if (instance.el) {
      instance.destroy();
      instance.el = null;
    }
    sortableGlobalInstances[index] = null; // Explicitly nullify instance
  });
  sortableGlobalInstances.length = 0; // Empty the array
};

export const trackMousePosition = (e: DragEvent) => {
  store.commit('liveEditor/setLastMousePosition', {
    x: e.clientX,
    y: e.clientY,
  });
};

export const startScrolling = (isTop: boolean) => {
  if (store.getters['liveEditor/getScrollAnimationId'] !== null) return;

  const iframeDocument = getTemplateIframeDocument();
  if (iframeDocument) {
    const scrollStep = () => {
      const currentScroll = iframeDocument.documentElement.scrollTop;
      const scrollAmount = isTop ? -15 : 15;

      iframeDocument.documentElement.scrollTop = currentScroll + scrollAmount;

      store.commit('liveEditor/setScrollAnimationId', requestAnimationFrame(scrollStep));
    };
    store.commit('liveEditor/setScrollAnimationId', requestAnimationFrame(scrollStep));
  }
};

export const stopScrolling = () => {
  if (store.getters['liveEditor/getScrollAnimationId'] !== null) {
    cancelAnimationFrame(store.getters['liveEditor/getScrollAnimationId']);
    store.commit('liveEditor/setScrollAnimationId', null);
  }
  store.commit('liveEditor/setLastMousePosition', null);
};

export const handleDrag = () => {
  if (store.getters['liveEditor/getLastMousePosition']) {
    const { x: clientX, y: clientY } = store.getters['liveEditor/getLastMousePosition'];
    const element = document.elementFromPoint(clientX, clientY);
    if (element && element.classList.contains('p-toolbar')) {
      const isTop = !element.classList.contains('toolbar-bottom');
      // Stop current scrolling before switching direction
      stopScrolling();

      // Start scrolling in the new direction
      startScrolling(isTop);
    } else {
      stopScrolling();
    }
  }
};

export const addDragAndDropSectionsListener = () => {
  const sections = getTemplateSections();
  const sectionsGroup: Maybe<HTMLElement & { isSortable?: boolean }> = sections[0]?.parentElement;
  if (sectionsGroup) {
    const disabled = ref(store.getters['liveEditor/getActiveEmbedPositionChooser']);
    if (typeof sectionsGroup.isSortable === 'undefined') {
      sectionsGroup.isSortable = true;
      const instance = Sortable.create(sectionsGroup, {
        group: { name: TemplateStructureEnum.SECTION, pull: [TemplateStructureEnum.SECTION], put: [TemplateStructureEnum.SECTION] },
        animation: ANIMATION_SPEED,
        handle: `${TEMPLATE_SECTION_IDENTIFIER}`,
        dragClass: BUILDER_SORTABLE_DRAG_CLASS,
        chosenClass: BUILDER_SORTABLE_CHOSEN_CLASS,
        ghostClass: BUILDER_SORTABLE_GHOST_CLASS,
        disabled: disabled.value,
        swapThreshold: 0.2,
        onStart(evt) {
          checkIfSavePointNeeded();

          const { item } = evt;

          // Listen to `dragover` to track mouse coordinates
          document.removeEventListener('dragover', trackMousePosition);
          document.addEventListener('dragover', trackMousePosition, { passive: true });

          // Attach drag event
          item.addEventListener('drag', handleDrag, { capture: true });
        },
        onMove() {
          stopScrolling();
        },
        onEnd(evt) {
          const { item } = evt;
          item.removeEventListener('drag', handleDrag);

          document.removeEventListener('dragover', trackMousePosition);

          stopScrolling();

          if (evt.oldIndex !== evt.newIndex) {
            // Update state
            refreshSectionsConfig();
            updateSectionsInState(false);
            createHistory(HistoryType.SECTIONS_ORDER_CHANGE);
            markTemplateAsEdited();
          }
        },
      });
      store.commit('liveEditor/addToSortableInstances', instance);
      sortableIframeInstances.push(instance);
    }
  }
};

export const addDragAndDropWidgetsListener = () => {
  const template = getTemplateIframeDocument();

  if (template) {
    const disabled = ref(store.getters['liveEditor/getActiveEmbedPositionChooser']);
    const widgetGroups = Array.from(template.querySelectorAll(WIDGET_DROPPABLE_CLASS));
    widgetGroups.forEach((groupWrapper: any) => {
      if (typeof groupWrapper.isSortable === 'undefined') {
        groupWrapper.isSortable = true;
        const instance = Sortable.create(groupWrapper as HTMLElement, {
          group: { name: TemplateStructureEnum.WIDGET, pull: [TemplateStructureEnum.WIDGET], put: [TemplateStructureEnum.WIDGET] },
          animation: ANIMATION_SPEED,
          handle: `${TEMPLATE_WIDGET_IDENTIFIER}`,
          dragClass: BUILDER_SORTABLE_DRAG_CLASS,
          chosenClass: BUILDER_SORTABLE_CHOSEN_CLASS,
          ghostClass: BUILDER_SORTABLE_GHOST_CLASS,
          disabled: disabled.value,
          swapThreshold: 0.2,
          onStart(evt) {
            checkIfSavePointNeeded();

            const { item } = evt;

            // Listen to `dragover` to track mouse coordinates
            document.removeEventListener('dragover', trackMousePosition);
            document.addEventListener('dragover', trackMousePosition, { passive: true });

            // Attach drag event
            item.addEventListener('drag', handleDrag, { capture: true });
          },
          onMove(evt) {
            stopScrolling();
            Array.from(template.querySelectorAll(`.${BUILDER_SORTABLE_PLACEHOLDER_HOVER_CLASS}`) ?? [])
              .forEach((element) => element.classList.remove(BUILDER_SORTABLE_PLACEHOLDER_HOVER_CLASS));

            const target = evt.related;
            if (target.classList.contains(WIDGETS_PLACEHOLDER_IDENTIFIER)) {
              evt.dragged.classList.add('spm_hide_on_builder');
              evt.dragged.classList.remove('spm_widgets_on_builder');
              const parent = target.parentElement;
              if (parent) {
                parent.classList.add(BUILDER_SORTABLE_PLACEHOLDER_HOVER_CLASS);
              }
            } else {
              evt.dragged.classList.remove('spm_hide_on_builder');
              evt.dragged.classList.add('spm_widgets_on_builder');
            }
          },
          onUnchoose() {
            Array.from(template.querySelectorAll(`.${BUILDER_SORTABLE_PLACEHOLDER_HOVER_CLASS}`) ?? [])
              .forEach((element) => element.classList.remove(BUILDER_SORTABLE_PLACEHOLDER_HOVER_CLASS));

            Array.from(template.querySelectorAll('.spm_widgets_on_builder') ?? [])
              .forEach((element) => element.classList.remove('spm_widgets_on_builder'));
          },
          onEnd(evt) {
            const { item } = evt;
            item.removeEventListener('drag', handleDrag);

            document.removeEventListener('dragover', trackMousePosition);

            stopScrolling();

            if (evt.from !== evt.to || evt.oldIndex !== evt.newIndex) {
              // SYNC ELEMENT WARNING
              // SYNC ELEMENT BLOCK
              const selectedSyncElement = store.getters['liveEditor/getSelectedSyncElement'];
              const sectionTo = getSectionParent(evt.to);
              const sectionFrom = getSectionParent(evt.from);

              // Remove class to hide the widget during the drag into a column with placeholder
              const removeClassToHideWidget = () => {
                evt.item.classList.remove('spm_hide_on_builder');
                evt.item.classList.remove('spm_widgets_on_builder');
              };

              const acceptCallback = (unlinkSyncWidget = false) => {
                removeClassToHideWidget();
                // Unlink widget if the widget to be dragged is sync
                if (unlinkSyncWidget) {
                  const oldSection = getSectionParent(evt.from);
                  const oldSectionId = oldSection?.getAttribute('data-spmelementid');
                  if (oldSection && oldSectionId) {
                    unlinkSyncElement({ elementType: TemplateStructureEnum.WIDGET, elementId: evt.item.id }, oldSectionId);
                  }
                }
                const destinationColumn = evt.to;

                // If destination column contains placeholder class, we remove it
                if (destinationColumn.classList.contains(COLUMN_WITH_PLACEHOLDER_CLASS)
                  || destinationColumn.classList.contains('spm_widgets_on_builder')) {
                  // Remove class and placeholder
                  destinationColumn.classList.remove(COLUMN_WITH_PLACEHOLDER_CLASS);
                  destinationColumn.classList.remove('spm_widgets_on_builder');

                  // If destination column contains a placeholder for widget, we remove it
                  if (destinationColumn.querySelector(`.${WIDGETS_PLACEHOLDER_IDENTIFIER}`)) {
                    // eslint-disable-next-line no-unused-expressions
                    destinationColumn.querySelector(`.${WIDGETS_PLACEHOLDER_IDENTIFIER}`)?.remove();
                  }
                }

                // We check if the widget is still in the same section, otherwise we modify its translations to insert the new section ID
                const [parentSectionFrom] = getParents(evt.from, `.${TEMPLATE_SECTION_CLASS}`);
                const [parentSectionTo] = getParents(evt.to, `.${TEMPLATE_SECTION_CLASS}`);

                const sectionFromId = parentSectionFrom?.getAttribute('data-spmelementid');
                const sectionToId = parentSectionTo?.getAttribute('data-spmelementid');

                if (evt.item.getAttribute('id')) {
                  moveWidgetFromSectionToAnother(evt.item.outerHTML, evt.item.getAttribute('id') || '', sectionFromId, sectionToId);
                }

                // We get the HTML code of the selected widget
                const widgetType = evt.item.getAttribute('data-widgettype');
                if (widgetType) {
                  if (widgetType === 'spm_widget_image') {
                    const image = evt.item.querySelector('img') as HTMLImageElement;
                    // hide image for parent calculation
                    image.classList.add('spm_hide_on_builder');
                    const parent = getParents(evt.item.querySelector('img'), WIDGET_DRAGGABLE_CLASS);
                    const currentMaxValue = parent && parent.length > 0 ? parent[0]?.offsetWidth : null;
                    // show image after parent calculation
                    image.classList.remove('spm_hide_on_builder');
                    // Resize is necessary ?
                    if ((image && currentMaxValue && (image.clientWidth > currentMaxValue || image.clientWidth > image.naturalWidth)) || (image && !currentMaxValue)) {
                      if (isEmailTemplate(state.template?.type)) {
                        setPerfectSizeForImage(image, '100%');
                      } else {
                        addOrUpdateDynamicStyle(`#${evt.item.getAttribute('id')} img`, { 'max-width': '100%' });
                        image.setAttribute('width', '100%');
                      }
                    }
                  }
                }

                // Add template part identifier if the element dragged has a style sync
                if (sectionTo
                  && sectionTo.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)
                  && !sectionTo.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE)
                  && evt.item.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE)
                  && evt.item.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)
                  && !evt.item.hasAttribute(TEMPLATE_PART_ELEMENT_IDENTIFIER)
                ) {
                  evt.item.setAttribute(TEMPLATE_PART_ELEMENT_IDENTIFIER, generateUniqStructureId());
                }
                if (sectionTo
                  && !sectionTo.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)
                  && !sectionTo.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE)
                  && evt.item.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE)
                  && evt.item.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)
                  && evt.item.hasAttribute(TEMPLATE_PART_ELEMENT_IDENTIFIER)
                ) {
                  evt.item.removeAttribute(TEMPLATE_PART_ELEMENT_IDENTIFIER);
                }

                // Update state
                updateSectionsInState(false);

                const currentSyncElement = store.getters['liveEditor/getSelectedSyncElement'];
                if (!currentSyncElement) {
                  createHistory(HistoryType.WIDGET_ORDER_CHANGE);
                }

                addColumnsListeners();
                addDragAndDropWidgetsListener();
                markTemplateAsEdited();
              };

              const rejectCallback = () => {
                removeClassToHideWidget();
                evt.from.insertBefore(evt.item, evt.from.children[evt.oldIndex as number]);
              };

              // Prevent dragging widget in sync design edit mode or sync styles edit mode
              if (selectedSyncElement && (selectedSyncElement.elementType === TemplateStructureEnum.DESIGN || selectedSyncElement.elementPartType === ElementPartTypeEnum.STYLES)) {
                rejectCallback();
                return;
              }

              const openConfigurationPanel = () => {
                const currentSyncElement = store.getters['liveEditor/getSelectedSyncElement'];
                togglePanel('configurationPanel', null).then(() => {
                  if (currentSyncElement) {
                    store.dispatch('liveEditor/prepareStructureConfiguration', currentSyncElement.structureConfiguration);
                  }
                });
              };

              // Reject dragging widget from another synced section expected the current synced section
              if (sectionFrom) {
                if (sectionFrom.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)
                  && !sectionFrom.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE)
                  && isEmailTemplate(state?.template?.type)
                ) {
                  if (!selectedSyncElement || (selectedSyncElement && selectedSyncElement.elementId !== sectionFrom.getAttribute('id'))) {
                    rejectCallback();
                    return;
                  }
                }
              }

              if (sectionTo) {
                const isSectionToSync = sectionTo.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)
                  && !sectionTo.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE) && isEmailTemplate(state?.template?.type);
                if (isSectionToSync && (!selectedSyncElement)) {
                  // Reject dragging widget from a synced section
                  if (sectionFrom
                    && sectionFrom.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)
                    && !sectionFrom.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE)
                    && isEmailTemplate(state?.template?.type)
                  ) {
                    rejectCallback();
                  } else {
                    store.dispatch('liveEditor/showSyncElementWarning', {
                      elementId: sectionTo.getAttribute('id'),
                      elementType: TemplateStructureEnum.SECTION,
                      acceptCallback: () => {
                        acceptCallback();
                        openConfigurationPanel();
                      },
                      rejectCallback,
                    });
                  }
                } else if (isSectionToSync && selectedSyncElement && selectedSyncElement.elementId === sectionTo.getAttribute('id')) {
                  acceptCallback();
                } else if (isSectionToSync && selectedSyncElement && selectedSyncElement.elementId !== sectionTo.getAttribute('id')) {
                  rejectCallback();
                } else if (!isSectionToSync && selectedSyncElement && selectedSyncElement.elementId !== sectionTo.getAttribute('id')) {
                  if (sectionFrom && sectionFrom.getAttribute('id') === selectedSyncElement.elementId) {
                    acceptCallback();
                  } else {
                    rejectCallback();
                  }
                } else if (!isSectionToSync && !selectedSyncElement) {
                  acceptCallback();
                }
              }
            }
          },
        });
        store.commit('liveEditor/addToSortableInstances', instance);
        sortableIframeInstances.push(instance);
      }
    });
  }
};

export const addDragAndDropLinesListener = () => {
  const template = getTemplateIframeDocument();

  if (template) {
    const linesGroups = Array.from(template.querySelectorAll('.spm_droppable_row'));
    linesGroups.forEach((groupWrapper: any) => {
      if (typeof groupWrapper.isSortable === 'undefined') {
        groupWrapper.isSortable = true;
        const instance = Sortable.create(groupWrapper as HTMLElement, {
          sort: false,
          group: { name: `${TemplateStructureEnum.LINE}_builder`, pull: false, put: [TemplateStructureEnum.LINE] },
          animation: ANIMATION_SPEED,
          onStart(evt) {
            const { item } = evt;

            // Listen to `dragover` to track mouse coordinates
            document.removeEventListener('dragover', trackMousePosition);
            document.addEventListener('dragover', trackMousePosition, { passive: true });

            // Attach drag event
            item.addEventListener('drag', handleDrag, { capture: true });
          },
          onMove() {
            stopScrolling();
          },
          onEnd(evt) {
            const { item } = evt;
            item.removeEventListener('drag', handleDrag);

            document.removeEventListener('dragover', trackMousePosition);

            stopScrolling();
          },
        });
        store.commit('liveEditor/addToSortableInstances', instance);
        sortableIframeInstances.push(instance);
      }
    });
  }
};

export const addDragAndDropListeners = () => {
  addOrRemoveJustImageClass();
  addDragAndDropSectionsListener();
  addDragAndDropLinesListener();
  addDragAndDropWidgetsListener();
};

export const resetListeners = () => {
  addSectionsListeners();
  addColumnsListeners();
  addWidgetsListeners();
  addDragAndDropListeners();

  // Unlock click on widgets and sections
  const template = getTemplateIframeDocument();
  // eslint-disable-next-line no-unused-expressions
  template.querySelector('body')?.classList.remove('iframe-locked');
};

const embedContainerListenerClick = (event: any) => {
  event.preventDefault();
  const element = event.currentTarget;
  checkIfSavePointNeeded().then(() => {
    // Create new selector
    if (element.hasAttribute('id') && element.getAttribute('id') !== '') {
      setTemplateConfigurationKeyInState('embedSelector', `${element.tagName.toLowerCase()}#${element.id}`);
    } else if (element.classList.length > 0) {
      element.classList.remove(BUILDER_EMBED_CONTAINER_HOVER_CLASS);
      setTemplateConfigurationKeyInState('embedSelector', `${element.tagName.toLowerCase()}.${Array.from(element.classList).join('.')}`);
    }

    // Remove all listeners on elements
    const template = getTemplateIframeDocument();
    const elements = Array.from(template.querySelectorAll(BUILDER_EMBED_TEMPLATE_CONTAINERS) ?? []);
    elements.forEach((el) => {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      el.removeEventListener('mouseover', embedContainerListenerMouseover);

      // Trigger mouseout event to remove click event listener
      const mouseoutEvent = new Event('mouseout');
      el.dispatchEvent(mouseoutEvent);

      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      el.removeEventListener('mouseout', embedContainerListenerMouseout);
    });

    // Remove hover class if needed
    Array.from(template.querySelectorAll(`.${BUILDER_EMBED_CONTAINER_HOVER_CLASS}`) ?? []).forEach((el) => {
      el.classList.remove(BUILDER_EMBED_CONTAINER_HOVER_CLASS);
    });

    // Insert template in new selector
    insertEmbedTemplateInSelectedElement();

    // Save new selector in HTML
    const selector = state.template?.configuration?.embedSelector;
    const spmBody = template.querySelector('#spm_body');
    if (spmBody) {
      spmBody.setAttribute('data-target-element', selector);
    }

    // Reset embed position chooser and re-open left panel
    store.commit('liveEditor/toggleEmbedPositionChooser', false);
    togglePanel('widgetsPanel');

    // Reset iframe
    resetIframe();

    // TODO save page url in spm_body attribute data-target-url (window.btoa)

    // Update state
    updateSectionsInState(false);

    // Create history point of save
    createHistory(HistoryType.EMBED_CHANGE_POSITION);
  });
};

const embedContainerListenerMouseover = (event: any) => {
  event.stopPropagation();
  const element: Element = event.currentTarget;
  element.classList.add(BUILDER_EMBED_CONTAINER_HOVER_CLASS);
  element.addEventListener('click', embedContainerListenerClick);
};

const embedContainerListenerMouseout = (event: any) => {
  event.stopPropagation();
  const element: Element = event.currentTarget;
  element.classList.remove(BUILDER_EMBED_CONTAINER_HOVER_CLASS);
  element.removeEventListener('click', embedContainerListenerClick);
};

/**
   * Add listeners on elements in which the user can place an embed template
   */
export const addEmbedContainersListeners = () => {
  // We remove the current embedded element
  const template = getTemplateIframeDocument();
  const embedElement = template?.querySelector('#spm_body');

  if (embedElement) {
    embedElement.remove();
  }

  // We add mouseenter event on elements
  const elements = Array.from(template.querySelectorAll(BUILDER_EMBED_TEMPLATE_CONTAINERS) ?? []);
  elements.forEach((element) => {
    let count = 0;

    if (element.classList.length > 0) {
      Array.from(element.classList).every((className) => {
        if (className !== '' && !className.match(/[^a-z0-9_-]/i)) {
          count = Array.from(template.querySelectorAll(`.${className}`) ?? []).length;

          if (count === 1) {
            return false;
          }
        }

        return true;
      });
    }

    if (element.id !== '' || count === 1) {
      element.addEventListener('mouseover', embedContainerListenerMouseover);
      element.addEventListener('mouseout', embedContainerListenerMouseout);
    }
  });
};
